export default __webpack_public_path__ + "static/media/image08.93d592d4.jpg";